import React from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import _get from 'lodash/get';
import ProductView from './ProductView';
import NotFoundPage from '../NotFoundPage';
import * as actions from '../../../actions/productData';
import ProductComponents from './ProductComponents';
import ProductQuickview from '../../common/ListingPage/quickview/ProductQuickview';
import BreadCrumb from '../../common/BreadCrumb';
import Loader from '../../common/Loader.js';
import ErrorMessage from '../../common/ErrorMessage';
import Layout from '../Layout';
import Error504 from '../../common/Error504';
import Error503 from '../../common/Error503';
import { showModal, hideModal } from '../../../actions/modal';
import {
  addToCart as addProductToCart,
  checkSelectedSize
} from '../../../actions/addProductToCart';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { DealOfTheDayTimerTag } from '../../common/DodCommonComponent/DodCommonComponent';
import { IsDealStart, IsDealEnd } from '../../common/DodCommonComponent/DodComponentFunctionality';
import { DealOfTheDayModal } from '../../common/DodCommonComponent/DodModals';
import Modal from '../../common/Modal';
import { getPriceErrorPdp } from '../../../utils/product';
import luxeScreen from '../../../refresh/constants/luxeScreenType';

import { generateRandomId } from '../../../edd/utils/utils';
import { getCartUrl } from '../../../refresh/utils/cartUtils';
import {
  gtmEventPush,
  luxeGtmProductImpressions,
  getStoreName,
  segmentEventPush,
  getProductItemPDP
} from '../../../modules/ga/GTMdatalayer';
import { signInCheck } from '../../common/CheckUserStatus';
import {
  getRecentlyViewsDetails,
  getSimilarStylesDetails,
  getCrossSellDetails,
  getEmiDetails,
  getServiceabilityDetailsDetails
} from '../../../refresh/selectors/productpage';
import { getCookie, createCookie, readCookie } from '../../common/Cookie';
import { getAjioStreetThemeFlags, getReturnCodCommunication, getEnableCrossSell, getEmiDiscountEnable, getEmiDiscountEnableForPDP } from '../../../refresh/selectors/featureFlagsSelector';
import ViewMoreEmiPlans from '../../../refresh/pages/ViewMoreEmiPlans';

const { pdp: { screenType = '', screenName = '' } = {} } = luxeScreen;

class Product extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fixedBtnProps: {
        popupBtnText: 'Go to Bag',
        popUpFirstBtnAction: () => {
          this.props.hideModal('order-summary-popup');
        },
        popUpSecondBtnText: 'Go to Cart',
        popUpSecondBtnAction: () => {
          window.location = getCartUrl(true);
        },
        firstBtnAction: orderTotalAmt => {
          if (orderTotalAmt) {
            this.props.showModal('order-summary-popup');
          }
        },
        secondBtnAction: this.props.addedToCart
          ? () => {
              window.location = getCartUrl(true);
            }
          : this.addToCart,
        secondBtnText: this.props.addedToCart ? 'Go to Bag' : 'Add To Bag',
        secondBtnVariant: this.props.addedToCart ? 'darkBlue' : 'gold',
        halfnhalfBtns: true
      },
      hasObserverBlockCall: false,
      viewMoreEmiPlans: false
    };
    this.viewProductBlockRef = React.createRef();
    this.handleObserver = this.handleObserver.bind(this);

    this.openViewMoreEmiModal = this.openViewMoreEmiModal.bind(this);
  }

  addToCart = debounce(
    () => {
      let selectedSizeCode = this.props.selectedSizeCode;
      const { commercialType = '', variantOptions = [] } = this.props.productData;
      let batchId = '';
      if (_get(variantOptions, 'length') > 0) {
        const sizeVariantOptionsArr = variantOptions.filter(variant => variant.code === code);
        const variantOptionQualifiers = _get(sizeVariantOptionsArr, '[0].variantOptionQualifiers');
        variantOptionQualifiers.forEach(variant => {
          if (variant.qualifier === 'imsBatchId') {
            batchId = variant.value;
          }
        });
      }
      console.log('TRACK BATCH ID ~ batchId:', batchId);
      console.log('TRACK COMMERICAL TYPE ~ commercialType:', commercialType);
      if (batchId || commercialType) {
        this.props.addProductToCart(selectedSizeCode, 'desktop', '', '', batchId, commercialType);
      } else {
        this.props.addProductToCart(selectedSizeCode, 'desktop');
      }
    },
    3000,
    { leading: true, trailing: false }
  );

  componentDidMount() {
    window.scrollTo(0, 0);
    const {
      product = {},
      sizeRecommendationPrimeAILinkFlag = false,
      newDesignLuxe,
      isStreet,
      returnCodCommunication,
      emiDiscountEnable = false,
      serviceabilityDetails
    } = this.props;
    const { code = '' } = product;
    if (code) {
      var cookie = getCookie('recentlyViewed');
      let recentlyViewedCookie = [];

      if (cookie) {
        recentlyViewedCookie = JSON.parse(cookie);
      }
      let isProductViewed = false;
      isProductViewed = recentlyViewedCookie.some(element => element.id == code);

      if (code && !isProductViewed) {
        // Add into state
        this.props.putRecentProducts({ id: code, store: isStreet ? 2 : newDesignLuxe ? 1 : 0 });
        recentlyViewedCookie.push({ id: code, store: isStreet ? 2 : newDesignLuxe ? 1 : 0 });

        if (recentlyViewedCookie?.length > 11) {
          recentlyViewedCookie.shift();
        }
        // Add into Cookie
        createCookie('recentlyViewed', JSON.stringify(recentlyViewedCookie));
      }
      let isReturnCommunicationPdpEnabled = returnCodCommunication?.isPdpEnabled;
      const {showEmi = false } = serviceabilityDetails;
      if (isReturnCommunicationPdpEnabled || (emiDiscountEnable && showEmi)) {
        this.props.fetchProductServiceability();
      }
    }

    // Recent view and similar product observer
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !this.state.hasObserverBlockCall) {
          this.setState({ hasObserverBlockCall: !this.state.hasObserverBlockCall });
          this.handleObserver();
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );
    if (this.viewProductBlockRef.current) observer.observe(this.viewProductBlockRef.current);
    if (sizeRecommendationPrimeAILinkFlag && !newDesignLuxe) {
      this.addRecommendedSizeScripts(code);
    }

    window.addEventListener('load', () => {
      const srFocus = document.getElementById('sr-init-focus');
      if (srFocus) {
        srFocus.focus({ preventScroll: true });

        const skipLink = document.getElementById('skip-link');
        if (skipLink) {
          skipLink.focus({ preventScroll: true });
        }
      }
    });
  }

  addRecommendedSizeScripts = code => {
    let headTag = document.getElementsByTagName('head')[0];

    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://www.primeai4.in/CUSTOMERS/rilajio/fitwidget/css/widget.css';

    headTag.appendChild(link);

    var tag = document.createElement('script');
    tag.src = 'https://code.jquery.com/jquery-3.4.1.js';
    headTag.appendChild(tag);

    var tag2 = document.createElement('script');
    tag2.async = true;
    tag2.type = 'text/javascript';
    tag2.src = 'https://www.primeai4.in/CUSTOMERS/rilajio/fitwidget/002-use-widget.js';
    tag2.setAttribute('data-retailerid', 'rilajio');
    tag2.setAttribute('data-productid', code);
    headTag.appendChild(tag2);
  };

  handleObserver = () => {
    let {
      product = {},
      newDesignLuxe,
      recentProductIds = [],
      similarProducts = [],
      recentProducts = [],
      crossSellProduct = []
    } = this.props;
    const data = Object.keys(product).length === 0 ? '' : product;
    let { code: productCode } = product;
    recentProductIds = recentProductIds.filter(e => e !== productCode);
    recentProductIds = recentProductIds.toString();
    if (Object.keys(data).length !== 0 && recentProductIds.length > 0) {
      let list = 'recently viewed widget';
      // this.productImpressionsEventPush(recentProducts, list);
      this.luxeEventPush({
        eventName: 'widget_view',
        event_category: 'widget interactions',
        event_action: 'widget view',
        event_label: list
      });
    }
    if (Object.keys(data).length !== 0 && similarProducts.length > 0) {
      let list = 'similar to widget';
      this.productImpressionsEventPush(similarProducts, list);
      this.luxeEventPush({
        eventName: 'widget_view',
        event_category: 'widget interactions',
        event_action: 'widget view',
        event_label: list
      });
    }
    if (Object.keys(data).length !== 0 && crossSellProduct.length > 0) {
      const widget_product_master = crossSellProduct.map(item => item.productColor.split('_')[0]).join(',');
      this.luxeEventPush({
        eventName: 'pdp_widget_impression',
        event_category: 'widget impression',
        event_action: 'cross-sell widget',
        event_label: 'Best Paired With',
        widget_product_master: widget_product_master
      });
    }
  };

  luxeEventPush = ({ eventName, ...rest }) => {
    const { product = {}, currentStore } = this.props;
    let {
      name,
      code,
      brickName,
      brickCategory,
      brickCode,
      brickSubCategory,
      price: { discountPercent },
      fnlColorVariantData: { color, brandName, productTag, exclusiveTill },
      wasPriceData: { displayformattedValue }
    } = product;
    
    let eventPushObj = {
      product_details: {
        product_name: name,
        product_id: code?.split('_')[0],
        product_brand: brandName,
        product_price: displayformattedValue,
        product_color: color,
        product_size: '',
        product_trade_discount: discountPercent,
        product_category: brickSubCategory,
        product_brick: brickCode,
        product_tag: exclusiveTill ? 'EXCLUSIVE' : productTag
      },
      user_details: {
        store_type: currentStore,
        user_status: signInCheck() ? 'logged in' : 'not logged In',
        time_of_the_day: '',
        login_type: signInCheck() ? 'logged in' : 'not logged In',
        page_name: screenName,
        page_type: screenType
      }
    };
    gtmEventPush({
      event: eventName,
      ...rest,
      ...eventPushObj.user_details,
      ...eventPushObj.product_details
    });
  };

  productImpressionsEventPush = (products, list) => {
    const { currentStore } = this.props;
    let impressions = [];
    products.map((data, index) => {
      const {
        description,
        code = '',
        productColor = '',
        priceValue = '',
        brand,
        brickName,
        isExclusive,
        productTag,
        discount,
        productCategory = '',
        productSize = '',
        productTagEngineValue,
        productPriceLabel,
        segmentId = '',
        experimentId = ''
      } = data;
      let productId = code.length > 9 ? code.substring(0, 9) : code;
      let tag = isExclusive ? 'EXCLUSIVE' : productTag;
      const dimension60Data =
        Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
      impressions.push({
        name: description,
        id: productId,
        price: priceValue,
        brand,
        category: productCategory,
        list: `pdp screen - ${list}`, // example only,
        position: index,
        dimension6: description, // pass value for product_name
        dimension7: productId, // pass value for product_id
        dimension8: brand, // pass value for product_brand
        dimension9: priceValue, // pass value for product_price
        dimension10: productColor ? productColor.split('_')[1] : '', // pass value for product_color
        dimension11: productSize, // pass value for product_size
        dimension12: discount, // pass value for product_trade_discount
        dimension13: productCategory, // pass value for product_category
        dimension14: brickName, // pass value for product_brick
        dimension15: tag, // pass value for product_tag
        dimension16: currentStore, // pass value for Store_type
        dimension23: getStoreName(),
        dimension60: dimension60Data,
        dimension89: productTagEngineValue,
        dimension90: productPriceLabel,
        dimension91: ''
      });
    });
    luxeGtmProductImpressions({
      impressions,
      list: 'pdp screen',
      store_type: currentStore,
      page_name: screenName,
      page_type: screenType,
      contains_luxe: true,
      ProductArray: impressions
    });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.props.getProductDetails(nextProps.match.params.id);
      this.props.putRecentProducts(this.props.match.params.id);
      this.props.resetImageSelection('true');
      this.props.selectSizeError('');
      this.props.selectSize('');
      window.scrollTo(0, 0);
    }
  }

  // Pricing Engine Error
  handlePricingEngineErrorPdp = () => {
    const currentUrl = window && window.location.href;
    let modify = currentUrl.split('?pfr');
    const newUrl = `${modify[0]}?pfr=${generateRandomId(18)}`;
    window.location.href = newUrl;
  };

  openViewMoreEmiModal = (status) => {
    const { product } = this.props;
    this.props.showModal('viewmore-emi-dialog');
    this.setState({ viewMoreEmiPlans: status });

    segmentEventPush({
      event: 'View EMI Plan Clicked',
      screen_source: 'pdp screen',
      products: [...(product ? [{ ...getProductItemPDP(product) }] : [])]
    })
  }

  render() {
    const { product = {}, errorHttp = {}, httpError = {}, newDesignLuxe, showCrossSellWidget=false, emiDetails } = this.props;
    let {
      stock: { stockLevelStatus = '' } = {},
      serviceErrors = [],
      shouldDisplayPricingError
    } = product;

    // checking shouldDisplayPricingError flag and serviceErrors
    const priceErrorPdp = getPriceErrorPdp(serviceErrors) && shouldDisplayPricingError;

    let fixedBtnProps = {
      popupBtnText: 'Go to Bag',
      popUpFirstBtnAction: () => {
        this.props.hideModal('order-summary-popup');
      },
      popUpSecondBtnText: 'Go to Cart',
      popUpSecondBtnAction: () => {
        window.location = getCartUrl(true);
      },
      firstBtnAction: orderTotalAmt => {
        if (orderTotalAmt) {
          this.props.showModal('order-summary-popup');
        }
      },
      secondBtnAction: this.props.addedToCart
        ? () => {
            window.location = getCartUrl(true);
          }
        : () => {
            this.props.checkSelectedSize(this.props.data, this.props.selectedSizeCode);
          },
      secondBtnText: this.props.addedToCart ? 'Go to Bag' : 'Add To Bag',
      secondBtnVariant: this.props.addedToCart ? 'darkBlue' : 'gold',
      halfnhalfBtns: true,
      secondBtnDisabled: stockLevelStatus === 'outOfStock'
    };
    if (errorHttp && errorHttp.errorCode == '504') {
      return <Error504 name="pdp" />;
    }
    if (errorHttp && errorHttp.errorCode == '503') {
      return <Error503 name="pdp" />;
    }

    const data = Object.keys(product).length === 0 ? '' : product;
    let { errors = [] } = product;
    if (Object.keys(data).length === 0 || errors.length) {
      return <NotFoundPage />;
    }
    let { rilfnlBreadCrumbList = {} } = data;
    let { rilfnlBreadCrumb = [] } = rilfnlBreadCrumbList;
    let { error: { message = '', originator = '', errorType = '', status = '' } = {} } = httpError;

    // DEAL OF THE DAY
    const isDodData = !!_get(product, 'variantOptions[0].priceData.deal');
    const dodProductDealStartTime =
      (isDodData && _get(product, 'variantOptions[0].priceData.deal.actualDealStartTime')) || '';
    const dodProductEndTime =
      (isDodData && _get(product, 'variantOptions[0].priceData.deal.dealEndTime')) || '';
    const { isDealStart = false } = dodProductDealStartTime && IsDealStart(dodProductDealStartTime);
    const { isDealEnd = true } = dodProductEndTime && IsDealEnd(dodProductEndTime);

    const topPdpTimerDod =
      isDealStart && !isDealEnd ? (
        <div className="dealOfDayTimer">
          <DealOfTheDayTimerTag
            dealOfTheDayProductTimer={dodProductEndTime}
            isStartIn
            topTimerOrProductTimer
            showModal={this.props.showModal}
            modalName="pdp-dod-time-up"
          />
        </div>
      ) : (
        ''
      );
    let marginTop = 100;
    marginTop = isDealStart && !isDealEnd ? (marginTop += 50) : marginTop;

    return (
      <>
        <div id="sr-init-focus" tabindex="-1" style={{position:'absolute', left:`-9999px`, height:`1px`, width:`1px`, overflow:`hidden`}}></div>
        <a
          className="skip-link"
          tabIndex={0}
          onClick={() => {
            window.location.href = '#main-content';
            const mainContent = document.getElementById('main-content');
            mainContent.tabIndex = '-1';
            mainContent.focus();
          }}
        >
          Skip To Content
        </a>
        <Layout fixedBtnProps={fixedBtnProps} moveToTop={true}>
          {topPdpTimerDod}
          <Modal
            name="pdp-dod-time-up"
            closeButton={false}
            disableOutsideClick
            className="dodModal"
          >
            <DealOfTheDayModal
              alt="Timer icon"
              logo="/static/img/timer.png"
              header="Time is up"
              timer
              subText="Sorry, deal is over. Although you can buy this product on an updated price"
              isStartIn={false}
              topTimerOrProductTimer
              pageRefresh
              modalName="pdp-dod-time-up"
            />
          </Modal>
          <div>
            <div
              className={`main-view product-view ${isDealStart &&
                !isDealEnd &&
                'pdp-deal-header-margin'}`}
            >
              {Object.keys(httpError).length != 0 && errorType && (
                <div className="err-msg-blk desktop_pdp">
                  <ErrorMessage message={message} />
                </div>
              )}
              {!(Object.keys(httpError).length != 0 && errorType) && status === 500 && (
                <div className="err-msg-blk desktop_pdp">
                  <ErrorMessage message="OOPS! Unable to add the product to your wishlist" />
                </div>
              )}
              {this.props.error && this.props.error.size_error && (
                <div className="err-msg-blk desktop_pdp">
                  <ErrorMessage message={this.props.error.size_error} />
                </div>
              )}
              {priceErrorPdp && (
                <div className="price-err-pdp" onClick={this.handlePricingEngineErrorPdp}>
                  Prices and discounts are being recalculated.
                  <span className="err-msg">Refresh now</span>
                </div>
              )}
              <Loader name="quick-view-loader" />
              {rilfnlBreadCrumb.length && <BreadCrumb breadcrumb={rilfnlBreadCrumb} />}
              <div className="prod-container">
                <ProductView productData={data} newDesignLuxe={newDesignLuxe} openViewMoreEmiModal={this.openViewMoreEmiModal}  />
              </div>
              <div className="comp-container jsdbf bjhdgbdjfxhg" ref={this.viewProductBlockRef}>
                <ProductComponents productData={data} newDesignLuxe={newDesignLuxe} />
              </div>
              <ProductQuickview newDesignLuxe={newDesignLuxe} />
            </div>
          </div>
        </Layout>
        {this.state.viewMoreEmiPlans &&
          <Modal
            name="viewmore-emi-dialog"
            className={'viewmore-emi-dialog'}
            onClose={() => {
              this.props.hideModal('viewmore-emi-dialog');
              this.setState({ viewMoreEmiPlans: false });
            }}
          >
            <ViewMoreEmiPlans isDesktop viewMoreEmiData={emiDetails?.plans} luxe={newDesignLuxe} productData={this.props.product} />
          </Modal>
        }
      </>
    );
  }

  componentWillUnmount() {
    this.props.emptyData('true');
    this.props.resetImageSelection('true');
    this.props.selectSizeError('');
    this.props.selectSize('');
    if (this.rootRef && this.rootRef.current) observer.unobserve(this.rootRef.current);
  }
}

const mapStateToProps = (state, ownProps) => {
  const { httpError = {}, flags = {} } = state;
  const errorHttp = httpError.pdp;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    newDesignLuxe,
    product: state.product.productDetails,
    error: state.error,
    errorHttp,
    httpError,
    addedToCart: state.popup.addedToCart,
    selectedSizeCode: state.product.selectedSizeCode,
    currentStore: storeName,
    recentProductIds: state?.recentlyViewed?.recent || [],
    recentProducts: getRecentlyViewsDetails(state),
    similarProduct: getSimilarStylesDetails(state),
    crossSellProduct: getCrossSellDetails(state),
    sizeRecommendationPrimeAILinkFlag: flags.sizeRecommendationPrimeAILinkFlag,
    isStreet: getAjioStreetThemeFlags(state, 'WEB'),
    returnCodCommunication: getReturnCodCommunication(state),
    showCrossSellWidget: getEnableCrossSell(state.flags),
    emiDetails: getEmiDetails(state),
    emiDiscountEnable: getEmiDiscountEnable(state) && getEmiDiscountEnableForPDP(state),
    serviceabilityDetails: getServiceabilityDetailsDetails(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getProductDetails: id => dispatch(actions.getProductDetails(id)),
    emptyData: data => dispatch(actions.emptyProductData(data)),
    resetImageSelection: data => dispatch(actions.resetImageSelection(data)),
    putRecentProducts: id => dispatch(actions.putRecentProducts(id)),
    selectSizeError: message => dispatch(actions.selectSizeError(message)),
    selectSize: productId => dispatch(actions.selectSize(productId)),
    hideModal: name => {
      dispatch(hideModal(name));
    },
    showModal: name => {
      dispatch(showModal(name));
    },
    addProductToCart: (...args) => dispatch(addProductToCart(...args)),
    checkSelectedSize: (data, selectedSizeCode) =>
      dispatch(checkSelectedSize(data, selectedSizeCode)),
    fetchProductServiceability: (...args) =>{
      import(/* webpackChunkName: "static/chunk/actions" */ '../../../refresh/pages/ProductPage/actions')
        .then(module => {
          const { fetchProductServiceability } = module;
          dispatch(fetchProductServiceability(...args)); // new serviceability api
        })
        .catch(error => console.log('err', error));
    },
  };
};

export default Product = connect(mapStateToProps, mapDispatchToProps)(Product);
